import { useIsCurrentViewReadOnly, useGetSaveAsNewViewProps } from 'framework-listing-lib/hooks/useCurrentView';
import { useViews } from 'framework-listing-lib/internal/ViewTabs/providers/ViewsProvider';
import ReadOnlyViewShepherd from './ReadOnlyViewShepherd';
import SaveViewShepherd from './SaveViewShepherd';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ViewShepherd({
  children,
  onOpenChange,
  onResetClick,
  onSaveAsNewClick,
  onSaveViewClick,
  open
}) {
  const isReadOnly = useIsCurrentViewReadOnly();
  const {
    isCurrentViewModified
  } = useViews();
  const saveAsNewViewProps = useGetSaveAsNewViewProps();
  if (saveAsNewViewProps.disabled) {
    return /*#__PURE__*/_jsx(ReadOnlyViewShepherd, {
      isCurrentViewModified: isCurrentViewModified,
      onOpenChange: onOpenChange,
      onResetClick: onResetClick,
      open: open,
      children: children
    });
  }
  return /*#__PURE__*/_jsx(SaveViewShepherd, {
    isCurrentViewModified: isCurrentViewModified,
    isReadOnly: isReadOnly,
    onOpenChange: onOpenChange,
    onResetClick: onResetClick,
    onSaveAsNewClick: onSaveAsNewClick,
    onSaveViewClick: onSaveViewClick,
    open: open,
    children: children
  });
}